<legend>Configurator Certificates</legend>

<certificate (onGenerateCertificateSubmit)="onGenerateCertificateSubmit($event)"
             (onLoadCertificateSubmit)="onLoadCertificateSubmit($event)"
             (onViewCurrentCertificate)="onViewCurrentCertificate()">
</certificate>
